export default {"src":"/evde-internet/_next/static/media/speed.3105a0f1.svg","height":36,"width":36};